import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
// import "./styles/floatingLanguageSelector.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import TransactionsList from "./pages/TransactionsList";
import TransactionDetail from "./pages/TransactionDetail";
import { PageMetadataProvider } from "./context/PageMetadataContext";
import CexStatistics from "./pages/CexStatistics";
import Operations from "./pages/Operations";
import Blocks from "./pages/Block";
import BlockDetail from "./pages/BlockDetail";
import AccountDetail from "./pages/AccountDetail";
import TermsOfService from "./pages/TermOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUs from "./pages/ContactUs";
import ReportScamWallet from "./pages/ReportScamWallet";
import Nodes from './pages/Nodes';
import NodesTestnet from './pages/NodesTestnet';
import UnlockStatistics from './pages/UnlockStatistics';
import UnlockStatisticsFull from "./pages/UnlockStatisticsFull";
import AccountStats from "./pages/AccountStats";
import { LanguageProvider } from './context/LanguageContext';
import FloatingLanguageSelector from "./components/FloatingLanguageSelector";
import { ThemeProvider } from "./context/ThemeContext";
import DomainAuctionStats from "./pages/DomainAuctionStats";
import LargestTx from "./pages/LargestTx";
import MigrateStatistics from "./pages/MigrateStatistics";
import TransactionsFilter from "./pages/TransactionsFilter";
import Assets from "./pages/Assets";
import AssetDetail from "./pages/AssetDetail";
import Trades from "./pages/Trades";
import PoolHistory from "./pages/PoolHistory";
import Pools from "./pages/Pools";
const App: React.FC = () => {
  return (
    <Router>
      <ThemeProvider>
      <LanguageProvider>
        <PageMetadataProvider>
          <div className="app">
            <Navbar />
            <div className=" container container-content mt-4">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/operations" element={<Operations />} />
                <Route path="/blocks" element={<Blocks />} />
                <Route path="/block/:sequence" element={<BlockDetail/>} />
                <Route path="/txs" element={<TransactionsList />} />
                <Route path="/tx/:id" element={<TransactionDetail />} />
                <Route path="/core-team-cex-statistics" element={<CexStatistics/>} />
                <Route path="/account/:address" element={<AccountDetail/>} />
                <Route path="/terms" element={<TermsOfService/>} />
                <Route path="/privacy" element={<PrivacyPolicy/>} />
                <Route path="/contact" element={<ContactUs/>} />
                <Route path="/report-scam" element={<ReportScamWallet/>} />
                <Route path="/nodes" element={<Nodes />} />
                <Route path="/nodes-testnet" element={<NodesTestnet />} />
                <Route path="/unlock-statistics" element={<UnlockStatistics />} />
                <Route path="/unlock-statistics-monthly" element={<UnlockStatisticsFull />} />
                <Route path="/account-stats" element={<AccountStats />} />
                <Route path="/domain-auction-stats" element={<DomainAuctionStats/>} />
                <Route path="/largest-tx" element={<LargestTx/>} />
                <Route path="/migrate-statistics" element={<MigrateStatistics/>} />
                <Route path="/txs/filter" element={<TransactionsFilter />} />
                <Route path="/assets" element={<Assets />} />
                <Route path="/asset/:assetId" element={<AssetDetail />} />
                <Route path="/trades" element={<Trades />} />
                <Route path="/pools" element={<Pools />} />
                <Route path="/pool/:poolId/history" element={<PoolHistory />} />
                <Route path="*" element={<div>404 Not Found</div>} />
              </Routes>
            </div>
            <Footer />
            <FloatingLanguageSelector />
          </div>
        </PageMetadataProvider>
      </LanguageProvider>
      </ThemeProvider>
    </Router>
  );
};

export default App;
